export default "__VITE_ASSET__CWR$H$64__"